import React, { type ReactElement, type FunctionComponent, cloneElement } from 'react'
import { type FormContextValues } from 'react-hook-form'
import { type BannerLocaleEnum } from 'domains/merchandising/api'
import { useIsI18nEnabled } from 'domains/merchandising/utils/useIsI18nEnabled.hooks'
import { useLocales } from 'domains/merchandising/utils/useLocales.hooks'
import languages from 'domains/merchandising/constants/languages'

const localeFieldName = 'locale'

interface Props {
  form: FormContextValues<any>
  field: (locale: BannerLocaleEnum) => ReactElement
  labelPrefixed?: boolean
}

export const MerchandisingI18nFormFieldContainer: FunctionComponent<Props> = ({
  field,
  form,
  labelPrefixed,
}) => {
  const locales = useLocales()

  const isI18nEnabled = useIsI18nEnabled()

  const { getValues, watch } = form

  watch(localeFieldName)

  const currentLocale = getValues(localeFieldName)

  return locales.map(locale => {
    const language = languages[locale.split('_')[0]]
    return (
      <div key={locale} hidden={locale !== currentLocale}>
        {cloneElement(field(locale), {
          labelPrefix:
            isI18nEnabled && labelPrefixed && locales.length > 1 ? `${language} ` : undefined,
        })}
      </div>
    )
  })
}
